import { render } from "./CommitteeView.vue?vue&type=template&id=75871f0e"
import script from "./CommitteeView.vue?vue&type=script&lang=js"
export * from "./CommitteeView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__